import {stringify} from "comment-json";
import {ElementsTree} from "../../../../model/ElementsTree";
import {Graph} from "../../../../model/Graph";
import {Playshot} from "../../../../model/Playshot";
import {getNodeIdFromProophBoardDescription} from "../../descriptions";
import {PlayshotChanged} from "../PlayshotChanged";
import {PlayEventRegistry} from "./event-definitions";
import {EventAdded} from "./EventAdded";
import {EventMetadataChanged} from "./EventMetadataChanged";
import {fqcnWithDefaultService} from "../../../cody-wizard/node/fqcn";
import {EventRenamed} from "./EventRenamed";
import {EventRemoved} from "./EventRemoved";

export const compareEvents = (oldPlayshot: Playshot, newPlayshot: Playshot, graph: Graph, elementsTree: ElementsTree): PlayshotChanged[] => {
  const oldEvents: PlayEventRegistry = oldPlayshot.playConfig.events;
  const newEvents: PlayEventRegistry = newPlayshot.playConfig.events;

  const changeSet: PlayshotChanged[] = [];

  const oldNames = Object.keys(oldEvents);
  const newNames = Object.keys(newEvents);

  const eventsToRemove: string[] = oldNames.filter(oldName => !newNames.includes(oldName));
  const eventsToAdd: string[] = newNames.filter(newName => !oldNames.includes(newName));

  const changedEvents: string[] = newNames.filter(newName => {
    if(eventsToAdd.includes(newName)) {
      return false;
    }

    const oldEvent = oldEvents[newName];
    const newEvent = newEvents[newName];

    return stringify(oldEvent) !== stringify(newEvent);
  })

  eventsToAdd.forEach(evtNameToAdd => {
    const evtToAdd = newEvents[evtNameToAdd];

    const existingNode = graph.getNode(getNodeIdFromProophBoardDescription(evtToAdd.desc));

    if(existingNode) {
      const oldName = fqcnWithDefaultService(existingNode, oldPlayshot.playConfig.defaultService);

      const oldInfo = oldPlayshot.playConfig.events[oldName];

      if(oldInfo) {
        changeSet.push(new EventRenamed(evtNameToAdd, getNodeIdFromProophBoardDescription(evtToAdd.desc), evtToAdd, oldInfo, newPlayshot, oldPlayshot));
        return;
      }
    }

    changeSet.push(new EventAdded(evtNameToAdd, getNodeIdFromProophBoardDescription(evtToAdd.desc), evtToAdd, newPlayshot));
  })

  changedEvents.forEach(evtNameToChange => {
    const evtToChange = newEvents[evtNameToChange];

    changeSet.push(new EventMetadataChanged(evtNameToChange, getNodeIdFromProophBoardDescription(evtToChange.desc), evtToChange, newPlayshot, oldPlayshot));
  })

  eventsToRemove.forEach(evtNameToRemove => {
    const evtToRemove = oldEvents[evtNameToRemove];

    changeSet.push(new EventRemoved(evtNameToRemove, getNodeIdFromProophBoardDescription(evtToRemove.desc), evtToRemove, oldPlayshot));
  })

  return changeSet;
}
